import { axiosGet, axiosPost } from "../options/header"


export default {
  getSuggestionTypes() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/suggestions/types", {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },

  addNewSuggestion(formData) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/suggestions/",formData, {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },

}